import { Body, Box, Icon } from '@hover/blueprint';
import { iCloudRain, iMonitor, iSun } from '@hover/icons';
import React from 'react';

export type CaseStudyTitles = 'problem' | 'solution' | 'products used';

interface Props {
  isActive: boolean;
  title: CaseStudyTitles;
  onSelect: (type: CaseStudyTitles) => void;
}

const renderIcon = (title: CaseStudyTitles, isActive: boolean) => {
  switch (title) {
    case 'problem':
      return (
        <Icon
          size="default"
          color={isActive ? 'brandNavy.500' : 'brandNavy.300'}
          icon={iCloudRain}
          mb={200}
        />
      );
    case 'solution':
      return (
        <Icon
          size="default"
          color={isActive ? 'brandNavy.500' : 'brandNavy.300'}
          icon={iSun}
          mb={200}
        />
      );
    case 'products used':
      return (
        <Icon
          size="default"
          color={isActive ? 'brandNavy.500' : 'brandNavy.300'}
          icon={iMonitor}
          mb={200}
        />
      );
    default:
      return (
        <Icon
          size="default"
          color={isActive ? 'brandNavy.500' : 'brandNavy.300'}
          icon={iCloudRain}
          mb={200}
        />
      );
  }
};

const TabItemMobile: React.FC<Props> = ({ isActive, title, onSelect }) => {
  const onClick = () => {
    onSelect(title);
  };

  return (
    <Box
      minW="30%"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
    >
      {renderIcon(title, isActive)}
      <Body
        mb={400}
        size={200}
        isBold
        color={isActive ? 'brandNavy.500' : 'brandNavy.300'}
        as="h4"
      >
        {title.toUpperCase()}
      </Body>
      {isActive && <Box w="100%" my={0} bg="brandNavy.500" h={25} />}
    </Box>
  );
};

export default TabItemMobile;
